import { toast } from 'sonner';

import { LoginHero, SocialLoginButtons } from '@/features/social-login';
import { supabase } from '@/shared/api';
import { MESSAGE } from '@/shared/consts';

const LOGIN_PENDING_STORAGE_KEY = 'mantang-login-pending';

const LoginContent = () => {
	const handleGoogleLogin = async () => {
		sessionStorage.setItem(LOGIN_PENDING_STORAGE_KEY, 'true');
		const { error } = await supabase.auth.signInWithOAuth({
			provider: 'google',
			options: {
				redirectTo: window.location.origin + import.meta.env.BASE_URL,
			},
		});

		if (error) {
			sessionStorage.removeItem(LOGIN_PENDING_STORAGE_KEY);
			toast.error(MESSAGE.ERROR.LOGIN_FAILED);
		}
	};

	const handleKakaoLogin = async () => {
		sessionStorage.setItem(LOGIN_PENDING_STORAGE_KEY, 'true');
		const { error } = await supabase.auth.signInWithOAuth({
			provider: 'kakao',
			options: {
				redirectTo: window.location.origin + import.meta.env.BASE_URL,
				scopes: 'account_email profile_image',
			},
		});

		if (error) {
			sessionStorage.removeItem(LOGIN_PENDING_STORAGE_KEY);
			toast.error(MESSAGE.ERROR.LOGIN_FAILED);
		}
	};

	const handleNaverLogin = () => {
		const state = crypto.randomUUID();
		const clientId = import.meta.env.VITE_NAVER_LOGIN_CLIENT_ID;
		if (!clientId) {
			toast.error(MESSAGE.ERROR.LOGIN_FAILED);
			return;
		}

		sessionStorage.setItem(LOGIN_PENDING_STORAGE_KEY, 'true');
		const redirectUri = encodeURIComponent(
			`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/naver-auth`,
		);
		window.location.href = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}`;
	};

	return (
		<>
			<LoginHero />
			<SocialLoginButtons
				onGoogleLogin={handleGoogleLogin}
				onKakaoLogin={handleKakaoLogin}
				onNaverLogin={handleNaverLogin}
			/>
		</>
	);
};

export default LoginContent;
